// file path: src\Utils\SortingActions.ts

import { SortCondition } from "../Types/project-task.type";

export const sortItemsAction = <T extends { [key: string]: any }>(items: T[], conditions: SortCondition[]): void => {
  if (conditions.length) {
    items.sort((a, b) => {
      for (let i = 0; i < conditions.length; i++) {
        const { column, order } = conditions[i];
        if (order === 'asc') {
          if (a[column] > b[column]) return 1;
          if (a[column] < b[column]) return -1;
        } else {
          if (a[column] < b[column]) return 1;
          if (a[column] > b[column]) return -1;
        }
      }
      return 0;
    });
  }
};
